import React from 'react'

const LayersContext = React.createContext({})

export const LayerProvider = LayersContext.Provider;
export const LayerConsumer = LayersContext.Consumer;

export default LayersContext